// Restrict file input to .jpg, .jpeg, .png only for upload receipt
Drupal.behaviors.restrictUploadFormats = {
    attach: function (context) {
        once('restrict-upload-formats', '.js-webform-image-file input[type="file"]', context).forEach(function (fileInput) {
            fileInput.setAttribute('accept', '.jpg,.jpeg,.png,image/jpeg,image/png');
        });
    }
};


// Prevent scroll to top on file upload button in webform
Drupal.behaviors.preventUploadScroll = {
    attach: function (context) {
        // Prevent scroll when file input receives focus
        once('prevent-upload-scroll-focus', '.js-webform-image-file input[type="file"]', context).forEach(function (fileInput) {
            // Store original focus method
            const originalFocus = fileInput.focus;
            
            // Override focus to prevent scroll
            fileInput.focus = function(options) {
                originalFocus.call(this, { preventScroll: true, ...options });
            };
            
            // Prevent scroll on actual focus event
            fileInput.addEventListener('focus', function(e) {
                const scrollY = window.scrollY;
                const scrollX = window.scrollX;
                
                // Restore scroll position immediately
                requestAnimationFrame(function() {
                    window.scrollTo(scrollX, scrollY);
                });
            }, true);
        });
        
        // Select all upload buttons in webform image/file wrappers
        once('prevent-upload-scroll', '.js-webform-image-file input[type="submit"]', context).forEach(function (uploadBtn) {
            uploadBtn.addEventListener('click', function (e) {
                // Prevent default scroll-to-top behavior
                if (document.activeElement && document.activeElement.type === 'file') {
                    // If the file input was just used, prevent scroll
                    e.preventDefault();
                    // Trigger the upload via AJAX if needed
                    uploadBtn.form && uploadBtn.form.dispatchEvent(new Event('submit', { cancelable: true }));
                }
            });
        });
    }
};

(function (Drupal, once) {
    'use strict';

    // Constants: Selectors and class names used throughout the code
    const SELECTORS = {
        errorAlert: 'div.alert.alert-dismissible.alert-danger[aria-label="Error message"]',
        webform: 'form.webform-submission-form',
        codeItem: '.js-form-item-code',
        description: '.description',
        copiedError: '.js-copied-error',
        formErrorMessage: '.js-form-error-message'
    };

    const CLASS_NAMES = {
        copiedError: 'js-copied-error',
        copiedErrorMessage: 'copied-error-message',
        formErrorMessage: 'js-form-error-message alert alert-danger'
    };

    const FORM_ERROR_SELECTORS = '.js-form-error-message, .js-copied-error, .form-item--error, .alert-danger';
    const pendingScrollForms = new WeakSet();

    // Regex pattern for matching "Please check your code..." messages
    const CODE_CHECK_PATTERN = /Please check your code[^\n(]*/i;

    Drupal.behaviors.copyFormError = {
        attach: function (context) {
            const scrollToForm = function (form) {
                if (!form || pendingScrollForms.has(form)) return;

                pendingScrollForms.add(form);
                requestAnimationFrame(function () {
                    const hasErrors = !!form.querySelector(FORM_ERROR_SELECTORS);
                    if (hasErrors) {
                        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                    pendingScrollForms.delete(form);
                });
            };

            /**
             * Helper function to extract text content from an element, excluding button elements.
             * This prevents button text (like "×" from close buttons) from appearing in error messages.
             * 
             * @param {HTMLElement} element - The element to extract text from
             * @returns {string} The text content without button text, trimmed
             */
            const getTextWithoutButtons = function (element) {
                const clone = element.cloneNode(true);
                const buttons = clone.querySelectorAll('button');
                buttons.forEach(function (button) {
                    button.remove();
                });
                return (clone.innerText || clone.textContent || '').trim();
            };

            /**
             * Handles DOM mutations to detect when error alerts are added to the page.
             * Checks both direct matches and searches within added subtrees.
             * 
             * @param {MutationRecord[]} mutations - Array of mutation records
             */
            const handleMutations = function (mutations) {
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (addedNode) {
                        if (!(addedNode instanceof HTMLElement)) return;

                        // Check if the added node itself is an error alert
                        if (addedNode.matches && addedNode.matches(SELECTORS.errorAlert)) {
                            copyErrorToForms(addedNode);
                        } else {
                            // Search inside the added subtree for error alerts
                            const alerts = addedNode.querySelectorAll && addedNode.querySelectorAll(SELECTORS.errorAlert);
                            if (alerts && alerts.length) {
                                alerts.forEach(function (alertElement) {
                                    copyErrorToForms(alertElement);
                                });
                            }
                        }
                    });
                });
            };

            /**
             * Extracts error message text from an alert element using three strategies:
             * 1. Regex match for "Please check your code..." messages
             * 2. Extract text after <hr> tag (for structured error messages)
             * 3. Final fallback: return full text (for other error types)
             * 
             * @param {HTMLElement} alertElement - The error alert DOM element
             * @returns {string|null} The extracted message text, or null if no message found
             */
            const extractShortMessage = function (alertElement) {
                // Get text content without button elements
                const allText = getTextWithoutButtons(alertElement);

                // Strategy 1: Check for "Please check your code..." pattern
                const codeCheckMatch = allText.match(CODE_CHECK_PATTERN);
                if (codeCheckMatch) {
                    return codeCheckMatch[0].trim();
                }

                // Strategy 2: If there is an <hr> tag, extract text after it
                const horizontalRule = alertElement.querySelector('hr');
                if (horizontalRule) {
                    let currentNode = horizontalRule.nextSibling;
                    let extractedText = '';

                    while (currentNode) {
                        if (currentNode.nodeType === 3) {
                            // Text node
                            extractedText += currentNode.textContent;
                        } else if (currentNode.nodeType === 1) {
                            // Element node
                            extractedText += ' ' + (currentNode.innerText || currentNode.textContent);
                        }
                        currentNode = currentNode.nextSibling;
                    }

                    // Strip trailing parentheses (backtraces/support codes)
                    extractedText = extractedText.trim().replace(/\(.*\)$/, '').trim();
                    return extractedText || null;
                }

                // Strategy 3: Final fallback - add full text to form at the beginning
                // This handles cases like network errors that don't match the first two patterns
                const webforms = document.querySelectorAll(SELECTORS.webform);
                webforms.forEach(function (form) {
                    // Check if error div already exists to avoid duplicates
                    if (form.querySelector(SELECTORS.formErrorMessage)) {
                        scrollToForm(form);
                        return;
                    }

                    const errorDiv = document.createElement('div');
                    errorDiv.className = CLASS_NAMES.formErrorMessage;
                    errorDiv.setAttribute('role', 'alert');
                    errorDiv.textContent = allText;

                    // Insert at the beginning of the form
                    form.insertBefore(errorDiv, form.firstChild);
                    scrollToForm(form);
                });

                // Return null so this message doesn't get added to code fieldset
                // (only the first two strategies add messages to code fieldset)
                return null;
            };

            /**
             * Copies the extracted error message to all webform submission forms on the page.
             * Inserts the message into the code fieldset description area.
             * 
             * @param {HTMLElement} alertElement - The error alert DOM element
             */
            const copyErrorToForms = function (alertElement) {
                // Extract the error message using the three-strategy approach
                const message = extractShortMessage(alertElement);

                // If no message was extracted, exit early
                if (!message) return;

                // Find all webform submission forms and insert the error message
                const webforms = document.querySelectorAll(SELECTORS.webform);
                webforms.forEach(function (form) {
                    const codeItem = form.querySelector(SELECTORS.codeItem);
                    if (!codeItem) return;

                    // Prefer the description container if present, otherwise use the code item itself
                    const description = codeItem.querySelector(SELECTORS.description) || codeItem;

                    // Don't duplicate if error message already exists in this code item
                    if (description.querySelector(SELECTORS.copiedError)) return;

                    // Create the error message container
                    const container = document.createElement('div');
                    container.className = CLASS_NAMES.copiedError;
                    container.setAttribute('role', 'alert');

                    const messageParagraph = document.createElement('p');
                    messageParagraph.className = CLASS_NAMES.copiedErrorMessage;
                    messageParagraph.textContent = message;
                    container.appendChild(messageParagraph);

                    // Append the message inside the description area
                    description.appendChild(container);
                    scrollToForm(form);
                });
            };

            // Set up MutationObserver to watch for dynamically added error alerts
            const observer = new MutationObserver(handleMutations);
            observer.observe(document.body, { childList: true, subtree: true });

            // Also process any existing error alerts on page load
            const existingAlerts = document.querySelectorAll(SELECTORS.errorAlert);
            existingAlerts.forEach(function (alertElement) {
                copyErrorToForms(alertElement);
            });

            once('scroll-existing-form-errors', SELECTORS.webform, context).forEach(function (form) {
                if (form.querySelector(FORM_ERROR_SELECTORS)) {
                    scrollToForm(form);
                }
            });
        }
    };
})(Drupal, once);
